export enum InnerMessageAuthorityMessageCode {
	DELETE_ALL = 'DELETE_ALL',
	GENERIC_SUCCESS = 'GENERIC_SUCCESS',
	GENERIC_ERROR = 'GENERIC_ERROR',
	AUTHORITY_CARGLASS_CLAIM_LINKED = 'AUTHORITY_CARGLASS_CLAIM_LINKED',
	AUTHORITY_CARGLASS_CLAIMS_LINKED = 'AUTHORITY_CARGLASS_CLAIMS_LINKED',
	AUTHORITY_CARGLASS_CLAIM_UNLINKED = 'AUTHORITY_CARGLASS_CLAIM_UNLINKED',
	AUTHORITY_CARGLASS_CLAIMS_UNLINKED = 'AUTHORITY_CARGLASS_CLAIMS_UNLINKED',
	AUTHORITY_CARGLASS_NO_CLAIMS_LINKED_ALERT = 'AUTHORITY_CARGLASS_NO_CLAIMS_LINKED_ALERT',
	AUTHORITY_CARGLASS_AUTHORIZED = 'AUTHORITY_CARGLASS_AUTHORIZED',
	AUTHORITY_CARGLASS_REJECTED = 'AUTHORITY_CARGLASS_REJECTED',
	AUTHORITY_SERVER_ERROR = 'AUTHORITY_SERVER_ERROR',
	AUTHORITY_BLACK_CUSTOMER = 'AUTHORITY_BLACK_CUSTOMER',
	AUTHORITY_APPOINTMENT_CREATE_OK = 'AUTHORITY_APPOINTMENT_CREATE_OK',
	AUTHORITY_APPOINTMENT_CREATE_KO = 'AUTHORITY_APPOINTMENT_CREATE_KO',
	AUTHORITY_APPOINTMENT_UPDATE_OK = 'AUTHORITY_APPOINTMENT_UPDATE_OK',
	AUTHORITY_APPOINTMENT_UPDATE_KO = 'AUTHORITY_APPOINTMENT_UPDATE_KO',
	AUTHORITY_QUOTATION_SAVED = 'AUTHORITY_QUOTATION_SAVED',
	AUTHORITY_QUOTATION_NOT_SAVED = 'AUTHORITY_QUOTATION_NOT_SAVED',
	AUTHORITY_CC_CONTRACT_NOT_EXIST = 'AUTHORITY_CC_CONTRACT_NOT_EXIST',
	AUTHORITY_CONTRACT_NOT_ACTIVE = 'AUTHORITY_CONTRACT_NOT_ACTIVE',
	AUTHORITY_CC_SEARCH_CONTRACT_RESULT_VOID = 'AUTHORITY_CC_SEARCH_CONTRACT_RESULT_VOID',
	AUTHORITY_SAVED = 'AUTHORITY_SAVED',
	AUTHORITY_NOT_SAVED = 'AUTHORITY_NOT_SAVED',
	AUTHORITY_OPERATION_SAVED = 'AUTHORITY_OPERATION_SAVED',
	AUTHORITY_GENERIC_SERVICE_ERROR = 'AUTHORITY_GENERIC_SERVICE_ERROR',
	AUTHORITY_DOSSIER_NOT_SAVED = 'AUTHORITY_DOSSIER_NOT_SAVED',
	AUTHORITY_SUCCESS_CREATE_WORKING = 'AUTHORITY_SUCCESS_CREATE_WORKING',
	AUTHORITY_SUCCESS_UPDATE_WORKING = 'AUTHORITY_SUCCESS_UPDATE_WORKING',
	AUTHORITY_SUCCESS_REMOVE_WORKING = 'AUTHORITY_SUCCESS_REMOVE_WORKING',
	AUTHORITY_SUCCESS_SEND_QUOTATION = 'AUTHORITY_SUCCESS_SEND_QUOTATION',
	AUTHORITY_SUCCESS_SEND_PARTS = 'AUTHORITY_SUCCESS_SEND_PARTS',
	AUTHORITY_SUCCESS_QUOTATION_CREATED = 'AUTHORITY_SUCCESS_QUOTATION_CREATED',
	AUTHORITY_SUCCESS_QUOTATION_DELETED = 'AUTHORITY_SUCCESS_QUOTATION_DELETED',
	AUTHORITY_SUCCESS_QUOTATION_AUTHORIZED = 'AUTHORITY_SUCCESS_QUOTATION_AUTHORIZED',
	AUTHORITY_SUCCESS_QUOTATION_DECLINED = 'AUTHORITY_SUCCESS_QUOTATION_DECLINED',
	AUTHORITY_SUCCESS_START_WORKING = 'AUTHORITY_SUCCESS_START_WORKING',
	AUTHORITY_SUCCESS_END_WORKING = 'AUTHORITY_SUCCESS_END_WORKING',
	AUTHORITY_SUCCESS_ATTACHMENTS_ADDED = 'AUTHORITY_SUCCESS_ATTACHMENTS_ADDED',
	AUTHORITY_SUCCESS_ATTACHMENTS_REMOVED = 'AUTHORITY_SUCCESS_ATTACHMENTS_REMOVED',
	AUTHORITY_ERROR_REMOVING_ATTACHMENTS = 'AUTHORITY_ERROR_REMOVING_ATTACHMENTS',
	AUTHORITY_ERROR_UPLOADING_ATTACHMENTS = 'AUTHORITY_ERROR_UPLOADING_ATTACHMENTS',
	AUTHORITY_SUCCESS_UPDATE_DEALER = 'AUTHORITY_SUCCESS_UPDATE_DEALER',
	AUTHORITY_SUCCESS_UPDATE_SINGLE_WARRANTY = 'AUTHORITY_SUCCESS_UPDATE_SINGLE_WARRANTY',
	AUTHORITY_SUCCESS_UPDATE_MULTI_WARRANTY = 'AUTHORITY_SUCCESS_UPDATE_MULTI_WARRANTY',
	AUTHORITY_SUCCESS_UPDATE_SINGLE_WARRANTY_EX = 'AUTHORITY_SUCCESS_UPDATE_SINGLE_WARRANTY_EX',
	AUTHORITY_SUCCESS_UPDATE_MULTI_WARRANTY_EX = 'AUTHORITY_SUCCESS_UPDATE_MULTI_WARRANTY_EX',
	AUTHORITY_ADD_PAPER_SIGN_CONVERT_TO_BASE64 = 'AUTHORITY_ADD_PAPER_SIGN_CONVERT_TO_BASE64',
	AUTHORITY_SUCCESS_C_FLOW_APPROVE = 'AUTHORITY_SUCCESS_C_FLOW_APPROVE',
	AUTHORITY_SUCCESS_C_FLOW_REJECT = 'AUTHORITY_SUCCESS_C_FLOW_REJECT',
	AUTHORITY_SUCCESS_C_FLOW_SEND = 'AUTHORITY_SUCCESS_C_FLOW_SEND',
	AUTHORITY_SUCCESS_GET_EXTRA_FEE = 'AUTHORITY_SUCCESS_GET_EXTRA_FEE',
	AUTHORITY_SUCCESS_REMOVED_EXTRA_FEE = 'AUTHORITY_SUCCESS_REMOVED_EXTRA_FEE',
	AUTHORITY_SUCCESS_PARTS_ARRIVED = 'AUTHORITY_SUCCESS_PARTS_ARRIVED',
	AUTHORITY_SUCCESS_CHANNELLING = 'AUTHORITY_SUCCESS_CHANNELLING',
	AUTHORITY_SUCCESS_CUSTOMER_INSERT = 'AUTHORITY_SUCCESS_CUSTOMER_INSERT',
	AUTHORITY_SUCCESS_INVOICES_DELETE = 'AUTHORITY_SUCCESS_INVOICES_DELETE',
	AUTHORITY_SUCCESS_CUSTOMER_EDIT = 'AUTHORITY_SUCCESS_CUSTOMER_EDIT',
	AUTHORITY_ACCEPTANCE_SECTIONS_VALIDATION = 'AUTHORITY_ACCEPTANCE_SECTIONS_VALIDATION',
	AUTHORITY_SUCCESS_DOWNLOAD_WOE_PDF = 'AUTHORITY_SUCCESS_DOWNLOAD_WOE_PDF',
	AUTHORITY_SUCCESS_SEND_PRACTICE_TO_FLEET = 'AUTHORITY_SUCCESS_SEND_PRACTICE_TO_FLEET',
	AUTHORITY_SUCCESS_SEND_PRACTICE_TO_CA = 'AUTHORITY_SUCCESS_SEND_PRACTICE_TO_CA',
	AUTHORITY_SUCCESS_STOP_WORK = 'AUTHORITY_SUCCESS_STOP_WORK',
	AUTHORITY_SUCCESS__REJECTED = 'AUTHORITY_SUCCESS__REJECTED',
	AUTHORITY_APPOINTMENT_NO_PRESENT = 'AUTHORITY_APPOINTMENT_NO_PRESENT',
	AUTHORITY_SUCCESS_CLOSED_DOSSIER = 'AUTHORITY_SUCCESS_CLOSED_DOSSIER',
	GATEWAY_1002 = 'GATEWAY_1002',
	AUTHORITY_CAN_T_ASSOCIATE_DEALER_FOR_REPAIR = 'AUTHORITY_CAN_T_ASSOCIATE_DEALER_FOR_REPAIR',
	NO_APPOINTMENT_FOR_PLATE = 'NO_APPOINTMENT_FOR_PLATE',
	AUTHORITY_SUCCESS_DELETED_DOSSIER = 'AUTHORITY_SUCCESS_DELETED_DOSSIER',
	AUTHORITY_APPOINTMENT_CAUSAL_LIST_ERROR = 'AUTHORITY_APPOINTMENT_CAUSAL_LIST_ERROR',
	AUTHORITY_HAS_QUOTATION_REFRESH_ERROR = 'AUTHORITY_HAS_QUOTATION_REFRESH_ERROR',
	AUTHORITY_HAS_QUOTATION_REFRESH_CRITICAL = 'AUTHORITY_HAS_QUOTATION_REFRESH_CRITICAL',
	AUTHORITY_SUCCESS_PART_REMOVED = 'AUTHORITY_SUCCESS_PART_REMOVED',
	AUTHORITY_QUOTATION_POLLING_ERROR = 'AUTHORITY_QUOTATION_POLLING_ERROR',
	AUTHORITY_SUCCESS_GENERAL_NOTE_CREATED = 'AUTHORITY_SUCCESS_GENERAL_NOTE_CREATED',
	AUTOMATICALLY_CLOSURE_WARNING = 'AUTOMATICALLY_CLOSURE_WARNING',
	AUTOMATICALLY_CLOSED_MESSAGE = 'AUTOMATICALLY_CLOSED_MESSAGE',
	AUTHORITY_CAN_T_ASSOCIATE_ALL_CLAIMS= 'AUTHORITY_CAN_T_ASSOCIATE_ALL_CLAIMS',
	AUTHORITY_CAN_T_CREATE_DOSSIER_WITH_CLAIM = 'AUTHORITY_CAN_T_CREATE_DOSSIER_WITH_CLAIM',
	AUTHORITY_CAN_CREATE_DOSSIER_WITH_CLAIM = 'AUTHORITY_CAN_CREATE_DOSSIER_WITH_CLAIM',
	AUTHORITY_CAN_CREATE_APPOINTMENT_WITH_CLAIM = 'AUTHORITY_CAN_CREATE_APPOINTMENT_WITH_CLAIM',
	AUTHORITY_NO_CLAIMS_FOUND = 'AUTHORITY_NO_CLAIMS_FOUND',

	AUTHORITY_SUCCESS_MASSIVE_CLOSURE = 'AUTHORITY_SUCCESS_MASSIVE_CLOSURE',
	AUTHORITY_PARTIAL_SUCCESS_MASSIVE_CLOSURE = 'AUTHORITY_PARTIAL_SUCCESS_MASSIVE_CLOSURE',
	AUTHORITY_SUCCESS_IMPORT = 'AUTHORITY_SUCCESS_IMPORT',
	AUTHORITY_SUCCESS_FORCE_QUOTATION_REFRESH = 'AUTHORITY_SUCCESS_FORCE_QUOTATION_REFRESH',

}
